import React, {FC} from 'react';

import {InboxModel} from '../../models/api/inboxModel';
import {SettingsInboxesUrl} from '../../models/url/settingsUrlModel';
import {SettingsPanelId} from '../../store/panels/panelStateBase';
import {SettingsBusinessHoursContainer} from '../businessHours/settingsBusinessHoursContainer';
import {StyledSettingsWrapper} from '../common/settingsWrapper';
import {SettingsInboxesInboxHeader} from './settingsInboxesInboxHeader';

/*
 * Props.
 */

interface SettingsInboxesBusinessHoursProps {
  url: SettingsInboxesUrl;
  inbox: InboxModel;
  onInboxUpdate: (inbox: InboxModel) => Promise<void>;
  panelId: SettingsPanelId;
}

/*
 * Component.
 */

export const SettingsInboxesBusinessHours: FC<SettingsInboxesBusinessHoursProps> = (props) => {
  const {url, inbox, onInboxUpdate, panelId} = props;

  return (
    <StyledSettingsWrapper>
      <SettingsInboxesInboxHeader url={url} inbox={inbox} />
      <SettingsBusinessHoursContainer
        url={url}
        inbox={inbox}
        onInboxUpdate={onInboxUpdate}
        panelId={panelId}
      />
    </StyledSettingsWrapper>
  );
};
